import styled from 'styled-components';

export const Icon = styled.i`
	font-size: 18px !important;
`;

export const StyledBackofficeHeader = styled.header`
	position: relative;
  box-shadow: 0 0 3px #C5C6D0;
  z-index: 1;

	.content {
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
	    color: #8B8C99;
		min-height: 56px;
		box-shadow: 0 0 10px #C5C6D0;
	    z-index: 1;
	
		.container-logo {
			width: 250px;
	        box-shadow: 0 0px 8px 0 rgba(0,0,0,0.1);
	        padding: 20px;
	        
	        img {
	            width: 100%;
	            margin: 0 auto;
	        }
		}
		
		ul {
			list-style: none;
			margin: 0;
			padding: 0;
		    margin: 0;
		    font-size: 16px;
		    
		    li {
		    	margin-bottom: 10px;
		    	
		    	&:last-child {
		    		margin-bottom: 0;
		    	}
		    }
		    
		    a {
		    	color: #444444;
		    	cursor: pointer;
		    
		    	&:hover {
						text-decoration: none;
		    		opacity: .7;
		    	}
		    }
		}
	}
`;

export const CollapseSidebar = styled.div`
	position: relative;
	display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-right: 30px;
    
    button {
    	background-color: transparent;
    	border: 0;
    	outline: 0 !important;
    }
	
	.user {
		padding: 3px;
		display: block;
		width: 32px;
	    height: 32px;
	    line-height: 30px;
	    border-radius: 32px;
	    text-align: center;
	    text-transform: uppercase;
	    color: #FFFFFF;
	    background-color: #4D4C59;
	    border: 2px solid transparent;
	    box-shadow: 0 0 1px 1px #FFFFFF inset;
	    background-size: cover;
	    background-position: center;
	    font-size: 1.6em;
	    font-weight: 500;
	    cursor: pointer;
	}
	
	.box {
		position: absolute;
	    top: 100%;
	    right: -10px;
	    background-color: #FFFFFF;
	    padding: 16px 24px;
	    box-shadow: 0 0 12px 0 rgba(0,0,0,0.2), 0 6px 8px 0 rgba(0,0,0,0.2);
	    border-radius: 4px;
	    width: 280px;
	    font-size: 1.4em;
	    transform: translateY(-64px);
	    opacity: 0;
	    transition: transform 0.3s, opacity 0.3s;
	    will-change: transform, opacity;
	    margin-top: 4px;
	    pointer-events: none;
	    z-index: 7;
	    
	    ul li a {
	    	display: flex;
	    	align-items: center;
	    	
	    	* {
	    		vertical-align: middle;
	    	}
	    }
	    
	    &.open {
	    	transform: translateY(-20px);
		    opacity: 1;
		    pointer-events: all;
	    }
	    
	    &:before {
	    	content: '';
	    	width: 12px;
		    height: 12px;
		    right: 24px;
		    position: absolute;
		    top: 0px;
		    background-color: #FFFFFF;
		    transform: rotate(45deg);
		    transform-origin: 12px 0px;
	    }
	}
`;
